import React, { forwardRef } from 'react';
import get from 'lodash.get';

import { Error, StyledLabel, StyledTextarea } from './styles';

const ReactHookTextarea = forwardRef(({ name, placeholder, defaultValue, errors, onChange, onBlur }, ref) => {
  const error = get(errors, name, false);

  return (
    <StyledLabel>
      <StyledTextarea
        ref={ref}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        defaultValue={defaultValue}
        placeholder={placeholder}
        rows={4}
      />
      {!!error && <Error isTextarea>{error.message || 'Field is not valid.'}</Error>}
    </StyledLabel>
  );
});

export { ReactHookTextarea };
